import { useIntl } from 'react-intl';
import { AuthoredEvidence, TableCells, TableColumn } from '@eas/common-web';
import { SystemUser } from '@models';

export function useColumns(): TableColumn<SystemUser>[] {
  const intl = useIntl();
  const { authoredColumns } = AuthoredEvidence.useAuthoredColumns<SystemUser>();

  return [
    {
      datakey: 'role.name',
      name: intl.formatMessage({
        id: 'TAPIS__USERS__COLUMN__ROLE',
        defaultMessage: 'Role',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'username',
      name: intl.formatMessage({
        id: 'TAPIS__USERS__COLUMN__IP_ADDRESS',
        defaultMessage: 'Uživatelské jméno',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'firstName',
      name: intl.formatMessage({
        id: 'TAPIS__USERS__COLUMN__FIRST_NAME',
        defaultMessage: 'Křestní jméno',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'lastName',
      name: intl.formatMessage({
        id: 'TAPIS__USERS__COLUMN__LAST_NAME',
        defaultMessage: 'Příjmení',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'email',
      name: intl.formatMessage({
        id: 'TAPIS__USERS__COLUMN__EMAIL',
        defaultMessage: 'Email',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },

    ...authoredColumns,
  ];
}
